import axios from 'axios';

export class ApplicationService {
    constructor() {
        axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('um-token')}`;
    }

    getApplications = async () => {
        return await axios.get('/api/application/applications');
    };

    getApplicationById = async (id) => {
        return await axios.get('/api/application/applicationbyid?id=' + id);
    };

    getallapprovers = async () => {
        return await axios.get('/api/application/getallapprovers');
    };

    getApproverDelegationDetails = async () => {
        return await axios.get('/api/approverdelegation/getapproverdelegationdetails');
    };

    getApprovaldetails = async (id) => {
        return await axios.get('/api/application/getapprovaldetails?id=' + id);
    };

    getApplicationglobalApprovers = async (id) => {
        return await axios.get('/api/application/getapplicationglobalApprovers?id=' + id);
    };

    saveApplication = async (application) => {
        return await axios.post('/api/application/save', application);
    };

    saveApplicationWiseCountriesInRegion = async (applicationId, regionId, countries) => {
        return await axios.post('/api/application/applicationWiseCountriesInRegion', {
            applicationId: applicationId,
            regionId: regionId,
            countries: countries
        });
    }

    getApplicationRegionCountry = async (appId, regionId) => {
        return await axios.get('/api/application/getApplicationRegionCountry?applicationId=' + appId + "&regionId=" + regionId);
    };

    saveApproverDelegation = async (appDelegation) => {
        return await axios.post('/api/approverdelegation/saveapproverdelegationnew', appDelegation);
    };

    getRelatedApplicationDetails = async () => {
        return await axios.get('/api/application/getrelatedapplicationdetails');
    };

    saveRelatedApplication = async (relatedApplication) => {
        return await axios.post('/api/application/saverelatedapplication', relatedApplication);
    };

    searchApprovers = async (appId, companyIds, countryIds, businessUnitIds, officeLocationIds) => {
        return await axios.post('/api/application/approvers', {
            applicationId: appId,
            selectedCompanyIds: companyIds,
            selectedCountryIds: countryIds,
            selectedBusinessUnitIds: businessUnitIds,
            selectedOfficeLocationIds: officeLocationIds
        });
    };

    saveApprover = async (applicationId, globalApprovers, approvers, companies, countries, businessUnits, officeLocations) => {
        return await axios.post('/api/application/approver', {
            applicationId: applicationId,
            globalApproverIds: globalApprovers,
            approverIds: approvers,
            selectedCompanyIds: companies,
            selectedCountryIds: countries,
            selectedBusinessUnitIds: businessUnits,
            selectedOfficeLocationIds: officeLocations
        });
    }

    deleteApprovalDelegation = async (id) => {
        return await axios.delete('/api/approverdelegation?id=' + id);
    }
}